import { createType } from '../utils/helpers';
import { generateTypes } from '../utils/HttpReducerHelper';

const fundingSearchActivities = generateTypes('ACTIVITIES', 'FUNDING_SEARCH_ACTIVITIES');
const dismissActivity = generateTypes('ACTIVITIES', 'DISMISS_ACTIVITY');
const triggerActivityAction = generateTypes('ACTIVITIES', 'TRIGGER_ACTIVITY_ACTION');
const completeActivity = generateTypes('ACTIVITIES', 'COMPLETE_ACTIVITY');
const uploadDocuments = generateTypes('ACTIVITIES', 'UPLOAD_DOCUMENTS');
const removeDocument = generateTypes('ACTIVITIES', 'REMOVE_DOCUMENT');
const OPEN_COLLECTIVE_ACTIVITIES_MODAL = createType(
  'ACTIVITIES',
  'OPEN_COLLECTIVE_ACTIVITIES_MODAL',
);
const CLOSE_COLLECTIVE_ACTIVITIES_MODAL = createType(
  'ACTIVITIES',
  'CLOSE_COLLECTIVE_ACTIVITIES_MODAL',
);
const COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED = createType(
  'ACTIVITIES',
  'COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED',
);
const collectiveActivities = generateTypes('ACTIVITIES', 'COLLECTIVE_ACTIVITIES');

export {
  fundingSearchActivities,
  dismissActivity,
  triggerActivityAction,
  completeActivity,
  uploadDocuments,
  removeDocument,
  OPEN_COLLECTIVE_ACTIVITIES_MODAL,
  CLOSE_COLLECTIVE_ACTIVITIES_MODAL,
  COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED,
  collectiveActivities,
};
